import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "6",
      height: "6",
      x: "16",
      y: "16",
      rx: "1"
    }, null, -1),
    _createElementVNode("rect", {
      width: "6",
      height: "6",
      x: "2",
      y: "16",
      rx: "1"
    }, null, -1),
    _createElementVNode("rect", {
      width: "6",
      height: "6",
      x: "9",
      y: "2",
      rx: "1"
    }, null, -1),
    _createElementVNode("path", { d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3M12 12V8" }, null, -1)
  ]))]))
}
export default { render: render }